import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { signOutFn } from '@/server/functions/auth';

export const Route = createFileRoute('/_auth/sign-out')({
    component: SignOutPage,
});

function SignOutPage() {
    useEffect(() => {
        void signOutFn();
    }, []);

    return (
        <div
            dir="rtl"
            lang="he"
            className="flex min-h-screen items-center justify-center bg-black text-sm text-white/55"
        >
            מתנתקים…
        </div>
    );
}
